var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('contraindications-warning-modal'),_c('diagnostic-results-warning-modal'),_c('forbidden-ingredient-warning-modal'),_c('online-offer-forbidden-warning-modal'),_c('recent-treatment-warning-modal'),_c('thin-skin-warning-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }